import { TextProps } from "@mantine/core"
import dayjs from "dayjs"

import { Missing } from "../Missing/Missing"

import { TextCell } from "./TextCell"

type Props = TextProps & {
  date?: Date | string | null
  format?: string
  textOnly?: boolean
}

const MONTH_FIRST_COUNTRIES = ["US", "PH", "PW", "FM", "BZ", "LR"]

export const DateCell = ({ date, ...textProps }: Props) => {
  if (!date) return <Missing {...textProps} />
  const browserLocale = navigator.language || navigator.languages[0]
  const isMonthFirst = isMonthFirstCountry(browserLocale)
  return (
    <TextCell
      value={dayjs(date)
        .locale(browserLocale)
        .format(isMonthFirst ? "MM/DD/YYYY" : "DD/MM/YYYY")}
      {...textProps}
    />
  )
}

export const DateCellItemInfo = ({ date, textOnly, ...textProps }: Props) => {
  if (!date) return <Missing {...textProps} />
  const browserLocale = navigator.language || navigator.languages[0]
  const isMonthFirst = isMonthFirstCountry(browserLocale)
  if (textOnly)
    return (
      <>
        {dayjs(date)
          .locale(browserLocale)
          .format(isMonthFirst ? "MM/DD/YYYY" : "DD/MM/YYYY")}
      </>
    )
  return (
    <TextCell
      value={dayjs(date)
        .locale(browserLocale)
        .format(isMonthFirst ? "MM/DD/YYYY" : "DD/MM/YYYY")}
      {...textProps}
    />
  )
}

const isMonthFirstCountry = (locale: string) => {
  const country = locale.split("-")[1]
  return MONTH_FIRST_COUNTRIES.includes(country)
}
